import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DeleteImageModal from "./modals/DeleteImageModal";
import { Dropdown } from "react-bootstrap";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import { GearFill, Plus } from "react-bootstrap-icons";
import UploadImageModal from "./modals/UploadImageModal";
import LoadingSpinner from "../../components/LoadingSpinner";
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import {LightGalleryKeyString} from "../../constants/LightGalleryKey"

export default function ClubImages() {
  const { id } = useParams();
  const { user } = useAuthContext();
  const [images, setImages] = useState([]);
  const [selectedImageId, setSelectedImageId] = useState(null);


  const [deleteImageModal, setDeleteImageModal] = useState(false);
  const [addImageModal, setAddImageModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navi = useNavigate();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const imageResponse = await axios.get(
        `${ApiConnectionString}/api/images?ClubId=${id}&ClubImage=true`
      );
      const orderedImages = imageResponse.data.sort(
        (a, b) => a.clubImageIndex - b.clubImageIndex
      );
      setImages(orderedImages);
    } catch (error) {
      console.error("Error fetching images:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const makeImgMain = async () => {
    setIsLoading(true);
    try {
      const mainResponse = await axios.post(
        `${ApiConnectionString}/api/Image/MakeMain/${selectedImageId}`,
        {},
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      if (mainResponse.status === 200) {
        fetchData();
      }
    } catch (error) {
      console.error("Error making image main:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const cancelModal = () => {
    setDeleteImageModal(false);
    setAddImageModal(false);
  };

  useEffect(() => {
    fetchData();
  }, [deleteImageModal, addImageModal, user]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="container bg-white">
      <button
        className="pointer cancelButton fw-bold m-2 px-3"
        onClick={() => navi(`/myoneclub/${id}`)}
      >
        Back to Club Page
      </button>

      <div className="blueBanner">
        <p className="fw-bold p-2">Club Images</p>
      </div>

     <button
          className="profile-blue-button my-2 d-flex"
          onClick={() => {
            setAddImageModal(true);
          }}
        >
          <Plus className="profile-social-icon" />
          <a className="fw-bold mx-2 mt-1"> Add Image</a>
        </button>

      <div className="row">
        {images.map((img, index) => (
          <div className="col-6 mb-4" key={img.id}>
            <Dropdown>
              <Dropdown.Toggle
                as="span"
                id="dropdown-custom-components"
                className="dropdown-toggle-custom"
              >
                <GearFill
                  style={{ cursor: "pointer" }}
                  onClick={() => setSelectedImageId(img.id)}
                />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setDeleteImageModal(true)}>
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <LightGallery licenseKey={LightGalleryKeyString}>
              <a
                href={`${ApiConnectionString}/api/Image/${img.id}`}
                className="lightgallery-item d-block ratio ratio-1x1 border rounded overflow-hidden"
              >
                <img
                  src={`${ApiConnectionString}/api/Image/${img.id}`}
                  alt="Club"
                  className="img-fluid w-100 h-100 object-fit-cover"
                />
              </a>
            </LightGallery>
          </div>
        ))}
      </div>

      {deleteImageModal && (
        <DeleteImageModal id={selectedImageId} cancelModal={cancelModal} />
      )}
      {addImageModal && <UploadImageModal cancelModal={cancelModal} id={id} />}
    </div>
  );
}
